import React, { useState } from "react";
import { Container } from "reactstrap";
import Header from "pages/operations/prospectDetails/Header";
import DataTabs from "pages/operations/prospectDetails/DataTabs";

const ProspectDetails = () => {
  const [acquisitionDate, setAcquisitionDate] = useState(null);
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Header acquisitionDate={acquisitionDate} />
          <DataTabs acquisitionDate={acquisitionDate} setAcquisitionDate={setAcquisitionDate} />
        </Container>
      </div>
    </>
  );
};
export default ProspectDetails;
